import React, {useState} from "react";
import NavbarWhite from "../components/NavbarWhite";
import Footer from "../components/Footer";
import "@fontsource/chivo";
import qrImage from "../qr-bar.png";
import { FaFilePdf } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FiLock } from "react-icons/fi"; // Add this to the imports



const BarRistorantePage = () => {
  const pdfUrl = "/menu-bar.pdf"; // This file should be in the public folder
  const [posto, setPosto] = useState("");
const [pin, setPin] = useState("");
const [message, setMessage] = useState(null);
const [isError, setIsError] = useState(false);
const navigate = useNavigate();


const handleVerify = async (e) => {
  e.preventDefault();
  try {
    const res = await axios.post("https://api.lidodavittorio.it/api/verify", { posto, pin });
    setMessage(res.data.message);
    setIsError(false);

    // Redirect after success
    navigate("/menu", {
      state: { posto, pin },
    });
  } catch (err) {
    setMessage(err.response?.data?.message || "Errore");
    setIsError(true);
  }
};


  return (
    <div className="bg-white text-black min-h-screen flex flex-col">
      <NavbarWhite />

      <div className="pt-32 px-4 sm:px-6 text-center flex-1">
      <div className="flex items-center justify-center gap-4 mb-12">
  <h1 className="text-4xl sm:text-5xl font-[chivo] text-[#009FB7]">
    Snack-Bar
  </h1>
  <button
    onClick={() => navigate("/admin-login")}
    className="text-[#009FB7] hover:text-[#007d99] transition text-2xl mt-1"
    title="Admin Login"
  >
    <FiLock />
  </button>
</div>


        {/* Menu Section */}
        <section className="mb-20 text-center">
          <p className="text-lg text-gray-700 font-[chivo] mb-8">
            Visualizza il menù in formato PDF oppure scansiona il QR code.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-10">
            {/* View Button */}
            <a
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-40 h-40 -mt-2 flex flex-col items-center justify-center bg-[#009FB7] text-white font-[chivo] text-base sm:text-lg rounded-lg hover:bg-[#007d99] transition duration-300 shadow-md"
            >
              <FaFilePdf className="text-white text-7xl mb-2" />
              Scarica il PDF
            </a>

            {/* QR Code */}
            <div className="mt-6 md:mt-0 text-center">
              <img
                src={qrImage}
                alt="QR Code Menu"
                className="w-40 h-40 mx-auto border border-gray-300 rounded-lg shadow-md"
              />
              <p className="text-sm text-gray-600 mt-2">Scansiona con il telefono</p>
            </div>
          </div>
        </section>

        {/* Order Section */}
{/* Order Section */}
<section className="mb-24 text-center px-4">
  <h2 className="text-3xl sm:text-4xl font-[chivo] text-[#009FB7] mb-6">
    Ordina direttamente dal tuo posto!
  </h2>

  {/* QR Code First */}
  <div className="mb-10">
    <p className="text-gray-700 font-[chivo] mb-4 text-base sm:text-lg">
      Scansiona il <strong>QR code</strong> al tuo Posto per accedere direttamente al menù!
    </p>
  </div>

  {/* Divider */}
  <div className="mb-8">
    <span className="text-sm text-gray-500 font-[chivo]">— Oppure —</span>
  </div>

  {/* Manual Input Form */}
  <p className="text-gray-700 font-[chivo] mb-6 text-base sm:text-lg">
    Inserisci il numero del tuo posto e il PIN ricevuto per iniziare l'ordine.
  </p>

  <form
    onSubmit={handleVerify}
    className="max-w-md mx-auto flex flex-col gap-4"
  >
    <input
      type="text"
      placeholder="N° Posto"
      value={posto}
      onChange={(e) => setPosto(e.target.value)}
      className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#009FB7] font-[chivo]"
    />
    <input
      type="password"
      placeholder="PIN"
      value={pin}
      onChange={(e) => setPin(e.target.value)}
      className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#009FB7] font-[chivo]"
    />
    <button
      type="submit"
      className="w-full px-6 py-3 bg-[#009FB7] text-white rounded-md hover:bg-[#007d99] transition font-[chivo]"
    >
      Ordina
    </button>
    {message && (
      <div className={`text-sm mt-2 font-[chivo] ${isError ? "text-red-600" : "text-green-600"}`}>
        {message}
      </div>
    )}
  </form>
</section>

      </div>

      <Footer />
    </div>
  );
};

export default BarRistorantePage;
